<div class="alert small" [class.alert-warning]="isWarning" [class.alert-info]="!isWarning">
  <lucide-icon [name]="isWarning ? 'triangle-alert' : 'info'" class="me-1"></lucide-icon>
  {{ noticeKey | translate }}
</div>

<div class="recovery-codes-container">
  <div class="recovery-codes-grid">
    @for (code of codes; track code) {
      <div class="recovery-code">{{ code }}</div>
    }
  </div>
</div>

<!-- Same two columns as the grid, so each button sits under one code column -->
<div class="recovery-codes-actions">
  <hc-button variant="secondary" size="md" [fullWidth]="true" [leftIcon]="copied ? 'check' : 'copy'" (clicked)="copyCodes()">
    {{ (copied ? 'profile.authenticators.copied' : 'copy') | translate }}
  </hc-button>
  <hc-button variant="secondary" size="md" [fullWidth]="true" leftIcon="download" (clicked)="downloadCodes()">
    {{ 'download' | translate }}
  </hc-button>
</div>
